import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { TASK_STATUS } from '../../../revampPages/EventInfo/config/constants';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#5E2755"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </components.DropdownIndicator>
);

const CustomMenuList = (props) => {
  const allowedValues = [TASK_STATUS.APPROVED, TASK_STATUS.REJECTED, TASK_STATUS.RE_SUBMIT];

  const filteredChildren = React.Children.toArray(props.children).filter(
    (child) => allowedValues.includes(child.props.data.value)
  );

  return <components.MenuList {...props}>{filteredChildren}</components.MenuList>;
};



const StatusInput = ({ onChangeHandle, width, value }) => {
  const statusOptions = [
    { label: 'Pending', value: TASK_STATUS.PENDING, color: "#fc6500", backgroundColor: "#f8ddcb" },
    { label: 'Submitted', value: TASK_STATUS.SUBMITTED, color: "#002e6e", backgroundColor: "#ebf3ff" },
    { label: 'Accepted', value: TASK_STATUS.ACCEPTED, color: "#cbffd3", backgroundColor: "#23a738" },
    { label: 'Approved', value: TASK_STATUS.APPROVED, color: "#23A738", backgroundColor: "#cbffd3" },
    { label: 'Rejected', value: TASK_STATUS.REJECTED, color: "#fff", backgroundColor: "#dc3545" },
    { label: 'Re-submit', value: TASK_STATUS.RE_SUBMIT, color: "#dc3545", backgroundColor: "#ffdbdf" },
  ];

  const selectedOption = statusOptions.find(option => option.value === value) || null;
  const [selected, setSelected] = useState(selectedOption);

  useEffect(() => {
    setSelected(selectedOption);
  }, [value]);

  const handleChange = (option) => {
    setSelected(option);
    if (onChangeHandle) {
      onChangeHandle(option);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '32px',
      fontSize: '12px',
      border: '1px solid #C3CDDF',
      boxShadow: 'none',
      borderRadius: '1px',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#444444',
      textTransform: 'none',
    }),
    singleValue: (provided, { data }) => ({
      ...provided,
      backgroundColor: data.backgroundColor,
      color: data.color,
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '12px',
      padding: '4px 8px',
      borderRadius: '4px',
      margin: 0,
      display: 'inline-flex',
      alignItems: 'center',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '4px',
      borderRadius: '1px',
      boxShadow: "0px 0px 12px 0px #00000040",
      padding: '8px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }),
    option: (provided, { data }) => ({
      ...provided,
      backgroundColor: data.backgroundColor,
      color: data.color,
      padding: '2px 5px',
      borderRadius: '4px',
      cursor: 'pointer',
      height: '24px',
      width: '85px',
      margin: '10px 10px',
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
  };

  return (
    <div style={{ width }}>
      <Select
        options={statusOptions}
        value={selected}
        onChange={handleChange}
        styles={customStyles}
        placeholder="Select status"
        components={{ DropdownIndicator, MenuList: CustomMenuList }}
        isSearchable={false}
      />
    </div>
  );
};

export default StatusInput;
